import { useQuery } from 'react-query';
import womBasketItemsServices from './womBasketItems.services';
import notificationError from '@/utils/functions/notificationError';
import { useWorkorderComplementSyncWithWom } from '../../workorder/WorkOrdersComplements/WorkOrdersComplements.hooks';

export const WOM_BASKET_ITEM_LIST_KEY = 'wom/basket-item/list';

export function useWomBasketItemList(
  workOrderComplementId?: number,
  workOrderId?: number,
  syncWom = true,
  enabled = true,
) {
  const womBasketSync = useWorkorderComplementSyncWithWom();

  return useQuery({
    queryKey: [WOM_BASKET_ITEM_LIST_KEY, { workOrderComplementId }],
    queryFn: () => womBasketItemsServices.listItems(workOrderComplementId),
    enabled: !!workOrderComplementId && enabled,
    refetchOnWindowFocus: enabled,
    async onSuccess() {
      if (workOrderComplementId && workOrderId && syncWom) {
        await womBasketSync.mutateAsync({
          complementId: workOrderComplementId,
          workOrderId: workOrderId,
        });
      }
    },
    onError(err) {
      notificationError(err);
    },
  });
}
